import { useNewAgent } from "../../contexts/NewAgentContext";
import PipelineConfiguration from "components/pipeline/pipeline-configuration";

const Pipeline = () => {
  const { formData, setFormData } = useNewAgent();

  return (
    <PipelineConfiguration
      value={formData.pipelines || []}
      onChange={(pipelines) => setFormData({ ...formData, pipelines })}
    />
  );
};

export default Pipeline;
